module.exports = __webpack_public_path__ + "static/media/twitter.a1472113.svg";